import React from 'react';
import { hex2, getSidName } from '../../../lib/nrcDecoder/constants';

// Byte-by-byte visual breakdown of a 3-byte UDS negative response (7F <SID> <NRC>).
// Plain flex columns rather than a <table> — this project has a known hydration-error
// gotcha with raw HTML tables, and a 3-cell breakdown needs no table semantics anyway.
const ResponseBreakdown = ({ sidCode, nrcCode }) => {
  const sidName = getSidName(sidCode);
  const cells = [
    { hex: '7F', top: 'NR', bottom: 'Negative Response', detail: 'Fixed marker byte — always 0x7F on any UDS negative response.' },
    { hex: hex2(sidCode), top: 'SID', bottom: 'Original Service ID', detail: sidName ? `Echo of the requested service: ${sidName} (0x${hex2(sidCode)}).` : `Echo of the requested service ID, 0x${hex2(sidCode)} (not in this tool's common SID list).` },
    { hex: hex2(nrcCode), top: 'NRC', bottom: 'Negative Response Code', detail: 'The reason the request was rejected — decoded below.' },
  ];

  return (
    <div className="rounded-md border border-structure bg-muted/30 p-4" data-testid="nrc-response-breakdown">
      <p className="font-mono text-[11px] uppercase tracking-wider text-muted-foreground mb-3">UDS Response Breakdown</p>
      <div className="flex flex-wrap items-start gap-x-2 gap-y-4">
        {cells.map((c, i) => (
          <React.Fragment key={c.top}>
            <div className="flex flex-col items-center text-center min-w-[84px]">
              <div className="font-mono text-2xl font-bold bg-background border border-structure rounded-md px-3 py-2" data-testid={`nrc-breakdown-byte-${i}`}>
                {c.hex}
              </div>
              <div className="text-muted-foreground text-lg leading-none my-1">&darr;</div>
              <div className="font-mono text-xs font-semibold uppercase tracking-wide">{c.top}</div>
              <div className="text-[11px] text-muted-foreground max-w-[140px] leading-snug mt-0.5">{c.bottom}</div>
            </div>
            {i < cells.length - 1 && (
              <div className="hidden sm:flex items-center text-muted-foreground/50 self-center text-lg px-1" aria-hidden="true">&rarr;</div>
            )}
          </React.Fragment>
        ))}
      </div>
      <ul className="mt-4 space-y-1.5 text-xs text-muted-foreground border-t border-structure pt-3">
        {cells.map((c) => (
          <li key={c.top}><span className="font-mono font-semibold text-foreground">{c.hex} ({c.top}):</span> {c.detail}</li>
        ))}
      </ul>
    </div>
  );
};

export default ResponseBreakdown;
